'use strict';

angular.module('app.home.timeline', ['highcharts-ng']);